<div #dialogContent class="dialog-container">
  <div *ngIf="loading" class="loadingMask">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div class="tab-wrapper">
    <p-tabView
      [(activeIndex)]="activeTabIndex"
      (activeIndexChange)="onTabChange($event)">
      <!-- User 內容 -->
      <p-tabPanel [header]="'HelpCenter.View.TabHeader' | translate">
        <div class="guide-body" [innerHTML]="releasedGuideContent"></div>
      </p-tabPanel>

      <!-- IT 內容 -->
      <p-tabPanel [header]="'HelpCenter.View.TabITHeader' | translate">
        <div class="guide-body" [innerHTML]="releasedGuideContentIT"></div>
      </p-tabPanel>

      <!-- 附件 -->
      <p-tabPanel [header]="'HelpCenter.View.TabFileHeader' | translate">
        <p *ngIf="docs.length === 0">
          {{ 'HelpCenter.Message.NotSet' | translate }}
        </p>

        <p *ngIf="docs.length !== 0" class="text-sm text-gray-500">
          {{ 'HelpCenter.Message.FilePrefix' | translate }}
        </p>

        <div class="flex flex-wrap gap-3 p-4">
          <div *ngFor="let doc of docs"
               class="flex manual-card align-items-center justify-content-between w-full">
            <div class="flex gap-2 align-items-center">
              <i class="pi pi-file text-xl"></i>
              <span class="font-semibold" style="color:#58595B">{{ doc.name }}</span>
              <div class="text-xs text-gray-500">
                {{ 'HelpCenter.Message.DatePrefix' | translate }}{{ doc.updateDt | date:'yyyy/MM/dd' }}
              </div>
            </div>

            <button pButton
                    class="p-button-sm p-button-outlined"
                    [label]="'HelpCenter.Button.DownloadFile' | translate"
                    icon="pi pi-download"
                    (click)="downloadDoc($event, doc)">
            </button>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>

    <button pButton
            class="tab-action-button p-button-text"
            icon="pi pi-external-link"
            [pTooltip]="'HelpCenter.Button.NavigateToSetting' | translate"
            tooltipPosition="left"
            (click)="navigateToSetting()">
    </button>
  </div>
</div>
